import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import {
  getUserFriendlyErrorMessageForHttpErrors,
  getUserFriendlyErrorMessageForNoInternet,
} from '@lockton-apps/shared/util/constants';
import { Connection } from '@lockton-apps/shared/util/helpers';
import { Router } from '@angular/router';
import { startsWith } from 'lodash';

@Injectable()
export class ErrorService {
  constructor(private readonly router: Router) {}
  getClientErrorMessage(error: Error): string {
    return error.message ? error.message : error.toString();
  }

  getServerErrorMessage(error: HttpErrorResponse): string | undefined {
    const isProposals: boolean = startsWith(this.router.url, '/proposals/');

    if (Connection.isOnline) {
      return getUserFriendlyErrorMessageForHttpErrors(error.status);
    }

    // Suppress within proposals, as this feature handles "no internet" errors internally
    if (isProposals) {
      return;
    }

    return getUserFriendlyErrorMessageForNoInternet();
  }

  getErrorStack(error: Error): string {
    return error.stack ? error.stack : '';
  }
}
